/* eslint-disable */
export default {
  _click: 'click',
  _combo: 'combo',
  _correct_slice: 'correct_slice',
  _game_over: 'game_over',
  _ninja_theme: 'ninja_theme',
  _object_tossed_1: 'object_tossed_1',
  _object_tossed_2: 'object_tossed_2',
  _object_tossed_3: 'object_tossed_3',
  _wrong_slice: 'wrong_slice',
}